export const stringHelpers = {
  equal: (
    input?: string,
    other?: string,
    options: {
      caseSensitive?: boolean;
    } = {}
  ) => {
    return input && other ? (options.caseSensitive ? input === other : input.toLowerCase() === other.toLowerCase()) : input === other;
  }
};

export const arrayHelpers = {
  createFrom: <T>(value: T): Array<NonNullable<T>> => {
    return value ? [value as NonNullable<T>] : [];
  }
};

export const isStringArray = (value?: string[] | string): value is string[] => {
  return !!value && !(typeof value === "string") && !!value.length;
};

export interface IProgressState {
  value: number;
  completed?: boolean;
}

export const getProgress = (current: number, total: number): IProgressState => {
  const value = Math.round((current / total) * 100);

  return {
    value: value,
    completed: value === 100
  };
};
